import type { ChangelogEntry } from '../types';

const entry: ChangelogEntry = {
  id: '2026-05-05-v0.6.1',
  version: '0.6.1',
  date: 'May 5, 2026',
  title: 'What\'s New Popup Hotfix',
  sections: [
    {
      heading: 'Bug Fix',
      bullets: [
        'Fixed the What\'s New popup so curators see the substantive v0.6.0 release notes instead of the older v0.5.0 notes.',
      ],
    },
  ],
};

export default entry;
